import Image from '@atlaskit/image';
import lozengeAnatomyLight from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-anatomy-light.png";
import lozengeAnatomyDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-anatomy-dark.png";
import lozengeStatusDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-status-do.png";
import lozengeStatusDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-status-dont.png";
import lozengeSemanticAccentDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-semantic-do.png";
import lozengeSemanticAccentDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-semantic-dont.png";
import lozengeTriggerDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-trigger-do.png";
import lozengeTriggerDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-trigger-dont.png";
import lozengeCaseDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-case-do.png";
import lozengeCaseDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-case-dont.png";
import lozengeBadgeDoLight from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-do-light.png";
import lozengeBadgeDontLight from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-dont-light.png";
import lozengeBadgeDoDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-do-dark.png";
import lozengeBadgeDontDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  lozengeAnatomyLight,
  lozengeAnatomyDark,
  lozengeStatusDo,
  lozengeStatusDont,
  lozengeSemanticAccentDo,
  lozengeSemanticAccentDont,
  lozengeTriggerDo,
  lozengeTriggerDont,
  lozengeCaseDo,
  lozengeCaseDont,
  lozengeBadgeDoLight,
  lozengeBadgeDontLight,
  lozengeBadgeDoDark,
  lozengeBadgeDontDark,
  React
};